import { render, staticRenderFns } from "./SdateCard.vue?vue&type=template&id=df3634ae&scoped=true&"
import script from "./SdateCard.vue?vue&type=script&lang=js&"
export * from "./SdateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3634ae",
  null
  
)

export default component.exports